import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  FadeWrapper,
} from '../../../components';
import HeroBig from '../../../components/HeroBig';
import HomepageTakeoverHeader from '../../../components/HomepageTakeoverHeader';
import { setTakeoverCookieAndReload } from '../../../helpers';

import './style.scss';

const ALLOWED_WIDE_PARAGRAPHS = [
  'video',
  'accordeon',
  'link_list',
];

const NodeHomePageTakeover = ({ entity }) => {
  const nid = entity.getIn(['nid', 0, 'value']);

  return (
    <article className="NodeHomePageTakeover">
      <HomepageTakeoverHeader
        onClose={() => setTakeoverCookieAndReload(`/node/${nid}`)}
      />
      <HeroBig
        entity={entity}
      />
      <div className="paragraphs-wrapper">
        {/* Start of paragraphs */}
        {entity.get('field_donation_paragraph') ? (
          <div className="node--page--paragraphs-wrapper">
            {entity.get('field_donation_paragraph', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const paragraphType = paragraph.getIn(['entity', 'type', 0, 'target_id']);
              return (
                <FadeWrapper key={`paragraph:${id}`}>
                  <Paragraph
                    id={id}
                    entity={paragraph.get('entity')}
                    wide={ALLOWED_WIDE_PARAGRAPHS.includes(paragraphType)}
                  />
                </FadeWrapper>
              );
            })}
          </div>
        ) : null}
        {/* End of paragraphs */}

        {/* Start of paragraphs */}
        <FadeWrapper delay={300}>
          {entity.get('field_paragraphs') ? (
            <div className="node--page--paragraphs-wrapper">
              {entity.get('field_paragraphs', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const paragraphType = paragraph.getIn(['entity', 'type', 0, 'target_id']);
                return (
                  <FadeWrapper key={`paragraph:${id}`}>
                    <Paragraph
                      key={`paragraph:${id}`}
                      id={id}
                      entity={paragraph.get('entity')}
                      wide={ALLOWED_WIDE_PARAGRAPHS.includes(paragraphType)}
                    />
                  </FadeWrapper>
                );
              })}
            </div>
          ) : null}
          {/* End of paragraphs */}
        </FadeWrapper>
      </div>


    </article>
  );
};

export default NodeHomePageTakeover;
